export default __webpack_public_path__ + "static/media/feature--help.7e2ba1b2.png";